import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { 
  LayoutDashboard, 
  Users, 
  Calendar, 
  FileCode, 
  History,
  Building2,
  Download,
  Upload
} from "lucide-react";
import { toast } from "sonner";

// Pages
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import Scadenze from "@/pages/Scadenze";
import GeneraXML from "@/pages/GeneraXML";
import Storico from "@/pages/Storico";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const navItems = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/clienti", icon: Users, label: "Anagrafiche" },
  { to: "/scadenze", icon: Calendar, label: "Scadenze" },
  { to: "/genera-xml", icon: FileCode, label: "Genera XML" },
  { to: "/storico", icon: History, label: "Storico" },
];

const Sidebar = () => {
  const location = useLocation();
  
  return (
    <aside className="w-64 bg-white border-r border-slate-200 h-screen sticky top-0 flex flex-col" data-testid="sidebar">
      <div className="p-6 border-b border-slate-200">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-slate-900 rounded-lg flex items-center justify-center">
            <Building2 className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-slate-900 text-sm">SEPA B2B</h1>
            <p className="text-xs text-slate-500">XML Generator</p>
          </div>
        </div>
      </div>
      
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.to || 
            (item.to !== "/" && location.pathname.startsWith(item.to));
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`sidebar-link ${isActive ? 'active' : ''}`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      
      <div className="p-4 border-t border-slate-200 space-y-2">
        <div className="flex gap-2">
          <button
            data-testid="backup-export-btn"
            onClick={() => {
              window.open(`${API}/backup/export`, '_blank');
              toast.success("Download backup avviato");
            }}
            className="flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-md hover:bg-slate-200 transition-colors"
          >
            <Download className="w-3.5 h-3.5" />
            Backup
          </button>
          <label
            data-testid="backup-restore-btn"
            className="flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-md hover:bg-slate-200 transition-colors cursor-pointer"
          >
            <Upload className="w-3.5 h-3.5" />
            Ripristina
            <input
              type="file"
              accept=".json"
              className="hidden"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (!file) return;
                const formData = new FormData();
                formData.append('file', file);
                try {
                  const res = await fetch(`${API}/backup/restore`, { method: 'POST', body: formData });
                  const data = await res.json();
                  if (res.ok) {
                    toast.success(`Ripristino completato: ${data.restored.clienti} clienti, ${data.restored.scadenze} scadenze, ${data.restored.xml_generations} generazioni`);
                    window.location.reload();
                  } else {
                    toast.error(data.detail || "Errore ripristino");
                  }
                } catch (err) {
                  toast.error("Errore di connessione");
                }
                e.target.value = '';
              }}
            />
          </label>
        </div>
        <div className="text-xs text-slate-500">
          <p className="font-medium text-slate-700 mb-1">Creditore</p>
          <p className="truncate">Silvia Casali Dottori Commercialisti</p>
        </div>
      </div>
    </aside>
  );
};

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clienti" element={<Clienti />} />
            <Route path="/scadenze" element={<Scadenze />} />
            <Route path="/genera-xml" element={<GeneraXML />} />
            <Route path="/storico" element={<Storico />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
